export class CitationViewer {
  constructor(
    private askOurDocsV2Service: any,
    private repoDetails: any,
    private enableCitationDownload: boolean
  ) {}

  public openSourceFile(citation: any, isMobileScreen: boolean): void {
    if (!this.enableCitationDownload) {
      return;
    }

    this.askOurDocsV2Service
      .getSasToken(this.repoDetails.internal_index_name)
      .then((response: any) => {
        const { sas_token, base_url } = response;
        let fullUrl = this.constructFullUrl(citation, base_url, sas_token);

        const fileType = citation.filepath?.split(".").pop()?.toLowerCase();
        if (fileType === "pdf" && !isMobileScreen) {
          const newWindow = window.open("", "_blank");
          this.showLoadingScreen(newWindow);

          const encodedUrl = btoa(unescape(encodeURIComponent(fullUrl)));
          const docUrl = encodeURIComponent(encodedUrl);

          this.askOurDocsV2Service
            .getFileWithPageNumber(docUrl, citation.content)
            .then((res: any) => {
              const urlWithPageNumber = `${fullUrl}#page=${
                res.pageNumber || 1
              }`;
              if (newWindow) {
                newWindow.location.href = urlWithPageNumber;
              }
            })
            .catch((err: any) => {
              console.error("Failed to fetch page number:", err);
              this.showErrorScreen(
                newWindow,
                "Failed to load specific page. Opening the document without it."
              );
              if (newWindow) {
                newWindow.location.href = fullUrl;
              }
            });
        } else {
          window.open(fullUrl, "_blank");
        }
      })
      .catch((err: any) => {
        console.error("Failed to fetch SAS token:", err);
        const newWindow = window.open("", "_blank");
        this.showErrorScreen(
          newWindow,
          "We couldn't load the document. Please try again later."
        );
      });
  }

  private constructFullUrl(
    citation: any,
    baseUrl: string,
    sasToken: string
  ): string {
    if (!citation.url || citation.url.includes(".seismic.com")) {
      return `${baseUrl}/${encodeURIComponent(
        citation.title || "default-title"
      )}${sasToken}`;
    } else if (!citation.url.includes("blob.core")) {
      return `${baseUrl}/${citation.url}${sasToken}`;
    } else {
      return citation.url;
    }
  }

  private showLoadingScreen(win: Window | null): void {
    if (!win) return;
    win.document.write(`
        <html>
          <head>
            <title>Loading Document...</title>
            <style>
              body {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100vh;
                font-family: sans-serif;
                font-size: 20px;
                color: #555;
                flex-direction: column;
              }
              .spinner {
                border: 2px solid #f3f3f3;
                border-top: 2px solid #e71316;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                animation: spin 1s linear infinite;
                margin-bottom: 15px;
              }
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            </style>
          </head>
          <body>
            <div class="spinner"></div>
            <div>Loading your document...</div>
          </body>
        </html>
      `);
    win.document.close();
  }

  private showErrorScreen(win: Window | null, message: string): void {
    if (!win) return;
    win.document.write(`
        <html>
          <head>
            <title>Error</title>
            <style>
              body {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100vh;
                font-family: sans-serif;
                font-size: 18px;
                color: #b00020;
                text-align: center;
              }
            </style>
          </head>
          <body>
            <div>${message}</div>
          </body>
        </html>
      `);
    win.document.close();
  }
}
